export class SchemaRecord {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "tables",
            "baseName": "tables",
            "type": "Array<TableRecord>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SchemaRecord.attributeTypeMap;
    }
    constructor() {
    }
}
